import React from 'react'
import { FormattedMessage } from 'react-intl'

import styles from './SharedStations.scss'
import { Link } from 'react-router-dom'
import { StationListItems } from '../../user/TopListItems'
import { IStation } from '../../../../models/Station'
import { useLocale, useLocationPermission } from '../../hocs/hooks'
import { getCurrentStationsUrl, getMapStationsUrl } from '../../../helpers/station'

const SharedStations = ({stations}: {stations: ReadonlyArray<IStation>}) => {
  const locale = useLocale()
  const isLocationPermission = useLocationPermission()

  return (
    <>
      <div className={styles.space118}/>
      <div className={[styles.mainPadding].join(' ')}>
        <div className={['d-flex justify-content-between ', styles.section].join(' ')}>
          <h2 className={[styles.title].join(' ')}>掲載中のスポット・体験</h2>
          <div className={styles.seeAll}>
            <Link to={isLocationPermission
              ? getCurrentStationsUrl(locale, false, true)
              : getMapStationsUrl(locale, false, true)} title="すべて見る">
              <FormattedMessage id="post.seeAll" />
            </Link>
          </div>
        </div>
        <div className={styles.mainSmPadding}>
          <StationListItems stations={stations} />
        </div>
      </div>
      <div className={styles.space120}/>
    </>
  )
}

SharedStations.displayName = 'SharedStations'
export default SharedStations
